import * as React from "react";

interface TruncateAddressProps {
  address: string;
  className?: string;
}

const TruncateAddress = ({ address, className }: TruncateAddressProps) => {
  const length = address.length;
  const firstPart = address.slice(0, length - 4);
  const lastPart = address.slice(length - 4);
  return (
    <div className={`flex ${className}`}>
      <div className="truncate">{firstPart}</div>
      <div>{lastPart}</div>
    </div>
  );
};

export default TruncateAddress;
